import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const IconDangerCircle: FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      {...props}
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.00001 0.667969C13.595 0.667969 17.3333 4.4063 17.3333 9.0013C17.3333 13.5963 13.595 17.3346 9.00001 17.3346C4.40501 17.3346 0.666672 13.5963 0.666672 9.0013C0.666672 4.4063 4.40501 0.667969 9.00001 0.667969ZM9.00001 1.91797C5.09417 1.91797 1.91667 5.09547 1.91667 9.0013C1.91667 12.9071 5.09417 16.0846 9.00001 16.0846C12.9058 16.0846 16.0833 12.9071 16.0833 9.0013C16.0833 5.09547 12.9058 1.91797 9.00001 1.91797ZM9.00325 11.3312C9.46409 11.3312 9.83659 11.7037 9.83659 12.1646C9.83659 12.6254 9.46409 12.9979 9.00325 12.9979C8.54242 12.9979 8.16576 12.6254 8.16576 12.1646C8.16576 11.7037 8.53492 11.3312 8.99492 11.3312H9.00325ZM8.99509 5.21297C9.34009 5.21297 9.62009 5.49297 9.62009 5.83797V9.52047C9.62009 9.86547 9.34009 10.1455 8.99509 10.1455C8.65009 10.1455 8.37009 9.86547 8.37009 9.52047V5.83797C8.37009 5.49297 8.65009 5.21297 8.99509 5.21297Z"
        fill={props.fill || "currentColor"}
      />
    </svg>
  );
};

export default IconDangerCircle;
